import { render, staticRenderFns } from "./ModalRegistroItem.vue?vue&type=template&id=67c6aeae&scoped=true"
import script from "./ModalRegistroItem.vue?vue&type=script&lang=js"
export * from "./ModalRegistroItem.vue?vue&type=script&lang=js"
import style0 from "./ModalRegistroItem.vue?vue&type=style&index=0&id=67c6aeae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c6aeae",
  null
  
)

export default component.exports